import React from 'react';
import ReactDOM from 'react-dom/client';
import './setupConsoleSilencing';
import './index.css';
import App from './App';
import { initErrorReporting } from './utils/errorReporting';
import { initAnalytics } from './utils/analytics';

// Both are no-ops unless their env vars are set (and, for GA4, the visitor
// has accepted analytics cookies). Sentry loads in a lazy chunk.
void initErrorReporting();
initAnalytics();

const rootElement = document.getElementById('root') as HTMLElement;
const isPrerendered = rootElement.getAttribute('data-prerendered') === 'true';

if (isPrerendered) {
  // Pre-rendered HTML exists — hydrate to attach React event handlers
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // No pre-rendered content — standard client-side render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
